import PropTypes from "prop-types";

import SuccessSvg from "assets/svg/success.svg";

import Button from "components/common/button";

import styles from "./styles.module.css";

const ActivationModal = ({ handleClick, success }) => {
  return (
    <div className={styles.wrapper}>
      {success ? (
        <div>
          <div className={styles.icon}>
            <SuccessSvg />
          </div>
          <p className={styles.title}>E-postanı Kontrol Et!</p>
          <p className={styles.info}>
            Aktivasyon bağlantısı e-posta adresine gönderilmiştir, lütfen e-posta adresini kontrol et.
          </p>
        </div>
      ) : (
        <div>
          <p className={styles.title}>Hesabını Aktive Et!</p>
          <p className={styles.info}>Giriş yapabilmek için lütfen aktivasyon işlemini tamamlayınız.</p>
          <div className={styles.activationButton}>
            <Button size="M" onClick={handleClick}>
              Aktivasyon Linki Gönder
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

ActivationModal.propTypes = {
  handleClick: PropTypes.func,
  success: PropTypes.bool,
};

export default ActivationModal;
